<template>
  <div class="chart-line" ref="chartdiv"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import * as _ from 'underscore'
import { mapGetters } from 'vuex'

export default {
  name: 'chartLineRender',
  props: {
    chartKey: { type: String, required: true },
    fromDialog: { type: Boolean, required: false }
  },
  data () {
    return {
      chartSettings: {},
      chartData: []
    }
  },
  computed: {
    ...mapGetters(['translation']),
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  mounted () {
    let self = this
    this.chartSettings = this.chartObj.chartSettings
    this.chartData = this.chartObj.data.result

    // assign value zeros for multiline charts
    if (this.chartSettings && this.chartSettings.multiline) {
      let dataValues = []
      this.chartData.forEach(item => {
        _.each(item, (value, name) => {
          if (!_.includes(dataValues, name)) {
            dataValues.push(name)
          }
        })
      })

      this.chartData.forEach(item => {
        dataValues.forEach(name => {
          if (!item[name] && item[name] !== 'name') item[name] = 0
        })
      })
    }

    // check and reduce data if not in dialog
    if (!this.fromDialog && this.chartData.length > (this.chartObj.chartSettings.displayLength || 10)) {
      const reducedData = this.chartData.filter((data, index) => index < (this.chartObj.chartSettings.displayLength || 10))
      // this.$log.info('reducedData', reducedData)
      this.chartData = reducedData
    }

    let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart)
    chart.paddingRight = 20
    chart.maskBullets = false // if true, LabelBullets will be outside graph
    chart.colors.step = self.chartObj.chartSettings.colorSteps || 1 // values color difference

    // Add data
    chart.data = this.chartData

    // Enable export if 'true' in chart setting
    /* if (this.chartObj.export) {
      chart.events.on('ready', () => {
        chart.exporting.menu = new am4core.ExportMenu()
        chart.exporting.menu.align = 'right'
        chart.exporting.menu.verticalAlign = 'bottom'
        chart.exporting.menu.items = [{
          'label': '...',
          'menu': [
            {
              'label': 'Image',
              'menu': [
                { 'type': 'png', 'label': 'PNG' },
                { 'type': 'jpg', 'label': 'JPG' },
                { 'type': 'gif', 'label': 'GIF' },
                { 'type': 'svg', 'label': 'SVG' },
                { 'type': 'pdf', 'label': 'PDF' }
              ]
            }, {
              'label': 'Data',
              'menu': [
                // { 'type': 'json', 'label': 'JSON' },
                { 'type': 'csv', 'label': 'CSV' }
                // { 'type': 'xlsx', 'label': 'XLSX' }
              ]
            }, {
              'label': 'Print', 'type': 'print'
            }
          ]
        }]
      })
    } */

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
    categoryAxis.dataFields.category = 'name'

    categoryAxis.renderer.grid.template.location = 0.5
    categoryAxis.renderer.minGridDistance = 30
    let categoryAxisLabel = categoryAxis.renderer.labels.template
    // if no label settings from dashboards use default
    categoryAxisLabel.rotation = self.chartSettings.labelRotation || 0
    categoryAxisLabel.horizontalCenter = self.chartSettings.labelHorizontalCenter || 'middle'
    categoryAxisLabel.verticalCenter = self.chartSettings.labelVerticalCenter || 'middle'
    // categoryAxisLabel.textAlign = self.chartSettings.textAlign || null
    self.chartSettings.truncate !== undefined
      ? categoryAxisLabel.truncate = self.chartSettings.truncate
      : categoryAxisLabel.truncate = true
    // categoryAxisLabel.maxWidth = 120 // if no auto max-width below
    // alternative to maxWidth
    categoryAxis.events.on('sizechanged', ev => {
      let axis = ev.target
      let cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex)
      axis.renderer.labels.template.maxWidth = cellWidth < 100 ? 100 : cellWidth
    })
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
    valueAxis.renderer.minWidth = 0
    valueAxis.min = 0

    let scrollbarX = new am4charts.XYChartScrollbar()
    let scrollbarSet = false
    // create series with function
    function createSeries (field, fieldName) {
      let series = chart.series.push(new am4charts.LineSeries())
      series.dataFields.valueY = field
      series.dataFields.categoryX = 'name'
      series.name = String(fieldName)
      series.strokeWidth = self.chartObj.chartSettings.strokeWidth || 1
      self.chartObj.chartSettings.fillOpacity === 0
        ? series.fillOpacity = 0
        : series.fillOpacity = self.chartObj.chartSettings.fillOpacity || 0.25
      self.chartObj.chartSettings.tensionX === 0
        ? series.tensionX = 0
        : series.tensionX = self.chartObj.chartSettings.tensionX || 0.77
      series.calculatePercent = true
      series.tooltipText = fieldName + `: {valueY.value} ({valueY.percent.formatNumber("#.#")}%)`
      let labelBullet = new am4charts.LabelBullet()
      series.bullets.push(labelBullet)
      labelBullet.label.text = '{valueY.value}'
      labelBullet.dy = -10

      series.legendSettings.labelText = fieldName

      if (chart.data.length > (self.chartObj.chartSettings.displayLength || 10)) {
        if (!scrollbarSet) {
          // scrollbarX.series.push(series)
          // scrollbarSet = true
        }
      }
    }

    let dataKeys = _.keys(this.chartData[0])
    _.each(dataKeys, function (key) {
      // skip name since it's category data
      if (key === 'name' || key === 'sort_column') {
        return
      }
      if (self.chartSettings.translation) {
        createSeries(key, self.translation(`chart.data.value.${key}`))
      } else {
        createSeries(key, key)
      }
    })

    // Enable scrollbar on top of graph
    if (chart.data.length > (self.chartObj.chartSettings.displayLength || 10)) {
      chart.scrollbarX = scrollbarX
    }
    chart.cursor = new am4charts.XYCursor()
    if (self.chartObj.chartSettings.legend) {
      chart.legend = new am4charts.Legend()
    }
    this.chart = chart
  },
  methods: {},
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .chart-line {
    width: 100%;
    height: 400px;
  }
</style>
